export default "__VITE_ASSET__DU6rrgLF__"